import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';

const SimpleRolesList: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        مدیریت نقش‌ها (نسخه ساده)
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Button variant="contained" color="primary">
          ایجاد نقش سازمانی
        </Button>
        <Button variant="contained" color="secondary">
          ایجاد نقش سراسری
        </Button>
      </Box>
      
      <Paper sx={{ p: 2 }}>
        <Typography>
          این یک نسخه ساده از صفحه مدیریت نقش‌هاست که بدون هیچ وابستگی به دسترسی‌ها یا سایر هوک‌ها ایجاد شده است.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SimpleRolesList; 